import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import IndianIndices from '../../pages/markets/component/indian-indices';

export const IndianIndicesWidget = ({ data }) => {
  const queryClient = new QueryClient();
  return (
    <QueryClientProvider client={queryClient}>
      <IndianIndices widget={true} />
    </QueryClientProvider>
  );
};
